import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'rizzui';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';
import PageHeader from '../../../layout/shared/page-header';
import { menuRoutes } from '../../../router/menu';
import FacilitatorAssignments from './FacilitatorAssignments';

const FacilitatorAssignmentsWrapper = () => {
    const navigate = useNavigate();
    const { userCan } = usePrivilege();
    const canViewPendingExtras = userCan('show_all_pending_contract_extras', 'contracts');

    return (
        <Fragment>
            <PageHeader
                title="Asignaciones de dinamizador"
                breadcrumb={[
                    { name: 'Ventas' },
                    { name: 'Gestión de campañas' },
                    { name: 'Asignaciones de dinamizador', href: menuRoutes.calls.path + menuRoutes.calls.assignments },
                ]}
            >
                <div className="mt-4 flex flex-wrap gap-2 md:mt-0">
                    {canViewPendingExtras && (
                        <Button variant="outline" onClick={() => navigate(menuRoutes.calls.path + menuRoutes.calls.pendingExtras)}>
                            Ver extras pendientes
                        </Button>
                    )}
                </div>
            </PageHeader>
            <FacilitatorAssignments />
        </Fragment>
    );
};

export default FacilitatorAssignmentsWrapper;
